import { PublicShell } from "../../components/Layouts";

export function PolicyPage({ title, eyebrow, children }) {
  return (
    <PublicShell>
      <main className="page">
        <div className="page-intro">
          <div className="eyebrow">{eyebrow}</div>
          <h1>{title}</h1>
        </div>
        <div className="prose">{children}</div>
      </main>
    </PublicShell>
  );
}

export const Terms = () => (
  <PolicyPage eyebrow="LEGAL" title="Terms & Conditions">
    <p>By using World Help Agency you accept these Terms. Participation is voluntary and you are responsible for the information you provide and the funds you commit.</p>
    <h3>Eligibility</h3>
    <p>You must be of legal age in your jurisdiction and permitted to engage in digital participation activities.</p>
    <h3>Packages</h3>
    <p>Package pricing, duration and daily production are defined by the administrator. Activation requires a confirmed deposit.</p>
    <h3>Withdrawals</h3>
    <p>All withdrawal requests are reviewed by the administrator before being released on-chain.</p>
    <h3>Changes</h3>
    <p>We may update these Terms. Material changes will be communicated through the platform.</p>
  </PolicyPage>
);

export const Privacy = () => (
  <PolicyPage eyebrow="LEGAL" title="Privacy Policy">
    <h3>Information we collect</h3>
    <p>Account information you submit (name, email, phone), authentication records and on-platform activity.</p>
    <h3>How we use it</h3>
    <p>To operate your account, process deposits and withdrawals, pay referral commissions and keep the platform secure.</p>
    <h3>Sharing</h3>
    <p>We do not sell your personal data. We may share limited data with service providers strictly needed to operate the platform.</p>
    <h3>Your choices</h3>
    <p>You can update your profile and wallet address from your member dashboard.</p>
  </PolicyPage>
);

export const Risk = () => (
  <PolicyPage eyebrow="LEGAL" title="Risk Disclosure">
    <p>Digital participation carries risks. Values and outcomes may change and are affected by factors outside the platform's control.</p>
    <h3>No guarantee of returns</h3>
    <p>Daily production levels are platform parameters and are not a guarantee of profit.</p>
    <h3>Blockchain risks</h3>
    <p>Transactions on BNB Smart Chain are final. Always verify the network, contract and wallet address before sending funds.</p>
    <h3>Operational risks</h3>
    <p>Technology, custody and regulatory conditions can change; be sure you understand what participation means for you.</p>
  </PolicyPage>
);

export const AML = () => (
  <PolicyPage eyebrow="LEGAL" title="AML Policy">
    <p>World Help Agency is committed to preventing money laundering and financial crime.</p>
    <h3>Our principles</h3>
    <p>We may request additional information if an activity appears inconsistent with normal participation.</p>
    <h3>Prohibited</h3>
    <p>Use of the platform is prohibited for sanctioned individuals and entities, or for activity connected to illegal sources of funds.</p>
    <h3>Cooperation</h3>
    <p>We cooperate with lawful requests from competent authorities.</p>
  </PolicyPage>
);
